import { useEffect, useState } from "react";
import { api } from "@/lib/api";

// Fetches admin-managed configurator option images for a group (e.g.
// "upper_body_shape"). Returns [] until loaded or if the admin hasn't
// added any yet — callers should fall back to a built-in default set.
export default function useConfigOptions(group) {
  const [options, setOptions] = useState([]);
  useEffect(() => {
    let live = true;
    api.get("/config-options", { params: { group } })
      .then(({ data }) => { if (live) setOptions(data || []); })
      .catch(() => {});
    return () => { live = false; };
  }, [group]);
  return options;
}
